module.exports = __webpack_public_path__ + "static/media/resetDarkIcon.915d9627.svg";